import React, {ReactElement} from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import {ExpandMoreRounded} from "@mui/icons-material";

export const ConfirmedTable = ({
                             item,
                           }: {
  item: any;
}): ReactElement => {

  console.log({item});

  return (
    <Table sx={{
      width: '100%'
    }} aria-label="simple table">
      <TableBody
        sx={{
          '& tr:last-child td, & tr:last-child th': {
            border: 0
          },
          ' .MuiTableCell-root': {
            padding: '2px',
          }
        }}
      >

        {item?.service_provider?.name && (
          <TableRow>
            <TableCell component="th" scope="row">
              Szolgáltató:
            </TableCell>
            <TableCell sx={{
              fontWeight: 'bold'
            }} dangerouslySetInnerHTML={{__html: item?.service_provider?.name}}></TableCell>
          </TableRow>
        )}

        <TableRow>
          <TableCell component="th" scope="row">
            Típus:
          </TableCell>
          <TableCell sx={{
            fontWeight: 'bold'
          }} dangerouslySetInnerHTML={{__html: item?.type}}></TableCell>
        </TableRow>

        {(item?.formatted_type === 'airport-transfer' || item?.formatted_type === 'transfer') && (
          <>
            <TableRow
            >
              <TableCell component="th" scope="row">
                Szolgáltatás:
              </TableCell>
              <TableCell>{item?.service}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">
                Program:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: item?.activity}}
              ></TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">
                Csoport:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html:item?.group}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Létszám:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html:item?.size}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Dátum:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html:item?.date}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Pickup:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html:item?.pickup_time}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Kezdés:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html:item?.start_time}}
              ></TableCell>
            </TableRow>
            {item?.formatted_type === 'airport-transfer' && (
              <TableRow>
                <TableCell component="th" scope="row">
                  Járatszám:
                </TableCell>
                <TableCell
                  dangerouslySetInnerHTML={{__html: item?.flight}}></TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell component="th" scope="row">
                Találkozási pont:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: item?.meeting_place}}
              ></TableCell>
            </TableRow>

          </>
        )}

        {(item?.formatted_type === 'event-staff' || item?.formatted_type === 'event-staff-airport-transfer') && (
          <>
            <TableRow>
              <TableCell component="th" scope="row">
                Fellépő:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: item?.event_staff}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Műsor:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: item?.service}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Program:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: item?.activity}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Csoport:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: item?.group}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Létszám:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: item?.size}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Dátum:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: item?.date}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Érkezés:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: (item?.formatted_type === 'event-staff-airport-transfer' ? item?.pickup_arrival_time: item?.arrival_time)}}
              >

              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Kezdés:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: (item?.formatted_type === 'event-staff' ? item?.start_time : item?.pickup_time)}}
              ></TableCell>
            </TableRow>
          </>
        )}

        {(item?.formatted_type === 'default') && (
          <>
            <TableRow>
              <TableCell component="th" scope="row">
                Szolgáltatás:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: item?.service}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Program:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: item?.activity}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Csoport:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: item?.group}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Létszám:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html:item?.size}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Dátum:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html:item?.date}}
              ></TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                Kezdés:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html:item?.start_time}}
              ></TableCell>
            </TableRow>
          </>
        )}

        <TableRow>
          <TableCell component="th" scope="row">
            Helyszín:
          </TableCell>
          <TableCell
            dangerouslySetInnerHTML={{__html:(item?.formatted_type === 'event-staff-airport-transfer' ? item?.meeting_place : item?.venue)}}
          ></TableCell>
        </TableRow>
        <TableRow>
          <TableCell component="th" scope="row">
            Guide:
          </TableCell>
          <TableCell
            dangerouslySetInnerHTML={{__html:item?.guide}}
          ></TableCell>
        </TableRow>
        {/*<TableRow>
          <TableCell component="th" scope="row">
            Ár:
          </TableCell>
          <TableCell
            dangerouslySetInnerHTML={{__html:item?.final_cost}}
          ></TableCell>
        </TableRow>*/}

        {item.formatted?.custom_fields && item.formatted.custom_fields.map((customField:any)=>{

          return (
            <TableRow>
              <TableCell component="th" scope="row">
                {customField?.column?.name}:
              </TableCell>
              <TableCell
                dangerouslySetInnerHTML={{__html: (customField?.value?.name ? customField?.value?.name : customField?.value)}}
              ></TableCell>
            </TableRow>
          );

        })}

        {item?.includes && (
          <TableRow>
            <TableCell colSpan={2} sx={{ padding: '2px !important' }}>
              <Accordion sx={{ background: '#f2f2f2', boxShadow: 'none' }}>
                <AccordionSummary expandIcon={<ExpandMoreRounded />}>
                  <Typography variant={'body2'}>Includes</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Box dangerouslySetInnerHTML={{ __html: item?.includes }} />
                </AccordionDetails>
              </Accordion>
            </TableCell>
          </TableRow>
        )}

      </TableBody>
    </Table>
  );

}